/* eslint-disable jsx-a11y/label-has-associated-control */
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Async from 'components/Async';
import MediaTypography from 'components/MediaTypography';
import useAvatarUpload from 'modules/Profile/hooks/useAvatarUpload';
import store from 'store';

import {
	StyledProfileAvatarOpacityBlock,
	StyledProfileAvatarWrap,
	StyledUserDataAvatar,
} from './styled';

function ProfileAvatar() {
	const { t } = useTranslation();
	const { getInputProps, getRootProps, isDragOver } = useAvatarUpload();

	return (
		<StyledProfileAvatarWrap
			{...getRootProps()}
			sx={{ border: store.profile?.partner?.is_premium ? '4px solid #FFD772' : 'none' }}
		>
			<input id="icon-button-file" {...getInputProps()} />
			<label htmlFor="icon-button-file">
				<StyledUserDataAvatar alt={store.profile.fullName} src={store.profile.avatar_url} />
			</label>
			<StyledProfileAvatarOpacityBlock isDragOver={isDragOver} className="backdrop">
				<Async loading={store.profile.imageUploadLoading}>
					<MediaTypography variant="body3" sx={{ height: 'auto' }}>
						{isDragOver ? t('profile.dropFile') : t('profile.clickOrDrop')}
					</MediaTypography>
				</Async>
			</StyledProfileAvatarOpacityBlock>
		</StyledProfileAvatarWrap>
	);
}

export default observer(ProfileAvatar);
